
import { arrowLeft, arrowRight } from '@/static/arrows';

export default {
  data() {
    return {
      slickOptions: {
        lazyLoad: 'progressive',
        variableWidth: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        speed: 400,
        prevArrow: arrowLeft,
        nextArrow: arrowRight,
        arrows: true,
        responsive: [
          {
            breakpoint: 1260,
            settings: {
              variableWidth: false,
              arrows: true,
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 920,
            settings: {
              variableWidth: false,
              arrows: true,
              slidesToShow: 1,
            }
          },
        ]
      },
      redirectVideoPage: 'video-slug',
      redirectEventPage: 'live-events-slug',
    };
  },
  props: {
    contentData: {
      type: Array,
      default: () => {
        return []
      },
    },
    isVideo: {
      type: Boolean,
      default: false,
    },
    isEvent: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {
    this.$emit('init')
  },
}
